// @flow

import {Dispatch} from "redux";
import type {PhotoEBadgeQueryPageDispatchProps} from "../../../components/ebadge/photo/PhotoEBadgeQueryPage";
import PhotoEBadgeQueryPage from "../../../components/ebadge/photo/PhotoEBadgeQueryPage";
import type {PhotoEBadgeSearchCriteria} from "../../../components/ebadge/photo/PhotoEBadgeSearchForm";
import {connect} from "react-redux";
import {
    photoEBadgeQueryAction,
    photoEBadgeQueryStartAction,
    photoEBadgeQuerySuccessAction
} from "../../../actions/ebadge/photo/creators/photoEBadgeQueryActionCreator";
import {change, reset} from "redux-form";
import * as _ from "lodash";

function mapDispatchToProps(dispatch: Dispatch): PhotoEBadgeQueryPageDispatchProps {

    return {
        loadSearchResultOnMount: (criteria: PhotoEBadgeSearchCriteria) => {

            dispatch(photoEBadgeQueryAction(criteria));
            dispatch(reset('PhotoEBadgeSearchForm'));
            _.chain(criteria).keys().forEach((key: string) => {
                dispatch(change('PhotoEBadgeSearchForm', key, criteria[key]));
            }).value();
        },
        unmount: () => {

            dispatch(photoEBadgeQueryStartAction({page: 0}));
            dispatch(photoEBadgeQuerySuccessAction([], 0));
        }
    }
}

export default connect(null, mapDispatchToProps)(PhotoEBadgeQueryPage);


// WEBPACK FOOTER //
// ./src/containers/ebadge/photo/PhotoEBadgeQueryPage.js